angular.module("Main").controller("OnlineSalesAbschlussController", ["$scope", "$q", "$uibModal", "$translate", "$window", "$stateParams", "BookingService",
    function ($scope, $q, $uibModal, $translate, $window, $stateParams, BookingService) {
        let vm = this;
        vm.parent = $scope.$parent.vm;
        if ($stateParams.id === 'tt') {
            vm.angebot = true;
            vm.vertrag = false;
        } else {
            vm.angebot = false;
            vm.vertrag = true;
        }
        vm.changedMemberValues = [];
        vm.memberValuesHasChangedChecked = false;
        vm.isAngebot = vm.parent.isAngebot;
        vm.foundAngebot = vm.parent.foundAngebot;
        vm.isVertrag = vm.parent.isVertrag;
        vm.chooseKostenpflichtig = false;
        vm.chooseAngebot = false;
        vm.vertragSaved = vm.parent.vertragSaved;
        vm.istVertrag = vm.parent.istVertrag;
        vm.istAngebot = vm.parent.istAngebot;
        vm.savedAngebotId = vm.parent.savedAngebotId;
        vm.pdf = vm.parent.pdf;
        vm.chooseAngebotStart = vm.parent.chooseAngebotStart;
        vm.choosenMemberAngebot = vm.parent.choosenMemberAngebot;
        vm.selectedFoundAngebot = vm.parent.selectedFoundAngebot;
        vm.choosenNewangebotForMember = vm.parent.choosenNewangebotForMember;
        vm.choosenMemberAngebotDatum = vm.parent.choosenMemberAngebotDatum;
        vm.selectedFoundAngebotDatum = vm.parent.selectedFoundAngebotDatum;
        vm.selectedMembershipAdds = vm.parent.selectedMembershipAdds;
        vm.selectedAdditionsGebuehrenIds = vm.parent.selectedAdditionsGebuehrenIds;
        vm.selectedAdditionsPauschalenIds = vm.parent.selectedAdditionsPauschalenIds;
        vm.selectedAdditionsIds = vm.parent.selectedAdditionsIds;
        vm.selectedMandantNr = vm.parent.selectedMandantNr;
        vm.pflichtZusatztarifePreis = vm.parent.pflichtZusatztarifePreis;
        vm.couponError = false;
        vm.isVorverkauf = false;
        vm.EntryStartOptionFix = false;
        vm.imgCanvas = null;
        vm.actualYear = moment().year();
        vm.regexBic = '([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)'
        vm.regexStreetAndNumber = '^(([a-zA-ZäöüÄÖÜ]\\D*)\\s+\\d+?\\s*.*)$';
        vm.isDeIban = false;
        vm.memberZip = true;
        vm.selectedAdditions = _.uniqWith(vm.parent.selectedAdditions, _.isEqual);
        vm.selectedAdditionsGesamt = vm.parent.selectedAdditionsGesamt;
        vm.selectedMembership = vm.parent.selectedMembership;
        vm.selectedMembership.VertragsbeginnOrig = vm.selectedMembership.Vertragsbeginn;
        if (!(vm.choosenMemberAngebotDatum || vm.selectedFoundAngebotDatum)) {
            vm.selectedMembership.ZugangsbeginnOrig = vm.selectedMembership.Zugangsbeginn;
        }
        vm.surveyId = vm.parent.surveyId;
        vm.basistarif = vm.parent.basistarif;
        vm.pflichtGebuehren = vm.parent.pflichtGebuehren;
        vm.pflichtGebuehrenOrig = _.uniqWith(vm.parent.pflichtGebuehrenOrig, _.isEqual);
        vm.SelectedAdditionsPauschalen = vm.parent.SelectedAdditionsPauschalen;
        vm.selectedAdditionsPauschalen = vm.parent.selectedAdditionsPauschalen;
        vm.selectedAdditionsGebuehren = vm.parent.selectedAdditionsGebuehren;
        vm.SelectedAdditionsGebuehren = vm.parent.SelectedAdditionsGebuehren;
        vm.showFormular = true;
        vm.onlineSalesConfig = vm.parent.onlineSalesConfig;
        vm.pflichtZusatztarife = vm.parent.pflichtZusatztarife;
        vm.layoutColors = vm.parent.layoutColors;
        vm.onlineSalesConfig = vm.parent.onlineSalesConfig;
        vm.layoutTexte6 = vm.parent.layoutTexte6;
        vm.layoutTexte5 = vm.parent.layoutTexte5;
        vm.today = moment().startOf("day").toDate();
        vm.selectedAdditionsGesamt = vm.parent.selectedAdditionsGesamt;
        if (_.isUndefined(vm.selectedAdditionsGesamt)) {
            vm.selectedAdditionsGesamt = 0;
        }
        vm.selectedPauschalenWithMembershipZyklus = vm.parent.selectedPauschalenWithMembershipZyklus ? vm.parent.selectedPauschalenWithMembershipZyklus : [];
        vm.selectedPauschalenWithMembershipZyklusIds = vm.parent.selectedPauschalenWithMembershipZyklusIds ? vm.parent.selectedPauschalenWithMembershipZyklusIds : [];
        vm.selectedPauschalenWithMembershipZyklusPreisGesamt = _.sumBy(vm.parent.selectedPauschalenWithMembershipZyklus, 'price');
        vm.member = vm.parent.selectedMember;
        if (vm.angebot && vm.parent.index !== 8) {
            if (vm.chooseAngebotStart) {
                vm.member.Vorname = vm.member.firstname;
                vm.member.Nachname = vm.member.lastname;
                vm.member.Geschlecht = vm.member.title;
                vm.member.Geburtsdatum = vm.member.birthday;
                vm.member.Email = vm.member.email;
                vm.member.StrasseNr = vm.member.street;
                vm.member.Plz = vm.member.zipcode;
                vm.member.Stadt = vm.member.city;
                vm.member.Mobil = vm.member.mobile;
                vm.member.Iban = vm.member.iban;
                vm.member.MandantId = vm.selectedMandantNr;
            } else {
                vm.member.firstname = vm.member.Vorname;
                vm.member.lastname = vm.member.Nachname;
                vm.member.title = _.isUndefined(vm.member.title) ? vm.member.Geschlecht : vm.member.title;
                vm.member.birthday = _.isUndefined(vm.member.birthday) ? (vm.member.Geburtsdatum ? new Date(vm.member.Geburtsdatum) : vm.member.birthday) : vm.member.birthday;
                vm.member.email = _.isUndefined(vm.member.email) ? vm.member.Email : vm.member.email;
                vm.member.street = _.isUndefined(vm.member.street) ? vm.member.StrasseNr : vm.member.street;
                vm.member.zipcode = _.isUndefined(vm.member.zipcode) ? vm.member.Plz : vm.member.zipcode;
                vm.member.city = _.isUndefined(vm.member.city) ? vm.member.Stadt : vm.member.city;
                vm.member.mobile = _.isUndefined(vm.member.mobile) ? vm.member.Mobil : vm.member.mobile;
                vm.member.iban = _.isUndefined(vm.member.iban) ? vm.member.Iban : vm.member.iban;
            }
        }

        if (vm.pflichtGebuehrenOrig.length > 0) {
            vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren, vm.pflichtGebuehrenOrig);
            vm.pflichtGebuehren = vm.pflichtGebuehren.filter(element => {
                return element !== undefined;
            });
            vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
            _.forEach(vm.pflichtGebuehren, function (g) {
                g.zahlzyklusName = g[0].zahlzyklus;
                g.gesamt = _.sumBy(g, 'price');
            });

        } else {
            vm.pflichtGebuehren = vm.parent.pflichtGebuehren ? vm.parent.pflichtGebuehren : _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren);

            if (!_.isArray(vm.pflichtGebuehren)) {
                let array = [];
                Object.keys(vm.pflichtGebuehren).map(key => {
                    array.push(vm.pflichtGebuehren[key]);
                });
                vm.pflichtGebuehren = _.flattenDeep(array);
            }

            vm.pflichtGebuehren = vm.pflichtGebuehren.filter(element => {
                return element !== undefined;
            });

            //  vm.selectedMembership.AngebotPflichtgebuehren = _.flattenDeep(vm.selectedMembership.AngebotPflichtgebuehren);
            vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
            _.forEach(vm.pflichtGebuehren, function (g) {
                g.zahlzyklusName = g[0].zahlzyklus;
                g.gesamt = _.sumBy(g, 'price');
            });
        }

        function setVertragsoptionenOptions(options) {
            vm.contractOptions = options;
            vm.vbMax = (options.FreeSelect && options.FreeSelectEndDate) ? options.FreeSelectEndDate : null;
            if (options.FixDate)
                vm.selectedMembership.Vertragsbeginn = options.ContractStart;
            else if (options.Select1Or15) {
                vm.selectedMembership.Vertragsbeginn = options.Select1Or15Dates[0];
                vm.Select1Or15 = true;
                vm.contractOptions.Select1Or15 = true;
                vm.contractOptions.Select1Or15Dates = options.Select1Or15Dates;
            }
            if (options.EntryStartOption === 2)
                vm.selectedMembership.Zugangsbeginn = vm.selectedMembership.Vertragsbeginn;
            else
                vm.selectedMembership.Zugangsbeginn = moment().startOf("day").toDate();

            recalculatePartialSum();
        }

        if (!vm.selectedMembership.FesterVertragsbeginn) {
            BookingService.getOnlineSalesContractOptions().then(function (options) {
                vm.contractOptions = options;
                setVertragsoptionenOptions(options)
            })

        } else {
            vm.contractOptions = vm.selectedMembership.FesterVertragsbeginn;
            let result = {
                FixDate: false,
                Select1Or15: false,
                Select1Or15Dates: [],
                FreeSelect: true,
                FreeSelectEndDate: null,
                ContractStart: moment().startOf("day").toDate(),
                EntryStartOption: 2
            };

            // if (config) {
            if (vm.selectedMembership.FesterVertragsbeginn.Zutrittsbeginn)
                result.EntryStartOption = vm.selectedMembership.FesterVertragsbeginn.Zutrittsbeginn;
            if (vm.selectedMembership.FesterVertragsbeginn.VorverkaufDatum) {
                vm.isVorverkauf = true;
                vm.selectedMembership.Vertragsbeginn = vm.selectedMembership.FesterVertragsbeginn.VorverkaufDatum;
                if (vm.selectedMembership.FesterVertragsbeginn.Zutrittsbeginn === 1) {
                    vm.selectedMembership.Zugangsbeginn = moment().startOf("day").toDate();
                    vm.EntryStartOptionFix = true;
                }
                if (vm.selectedMembership.FesterVertragsbeginn.Zutrittsbeginn === 2) {
                    vm.selectedMembership.Zugangsbeginn = vm.selectedMembership.FesterVertragsbeginn.VorverkaufDatum;
                    vm.EntryStartOptionFix = true;
                }

                recalculatePartialSum();
            } else {
                if (vm.selectedMembership.FesterVertragsbeginn.FV_OE === 2 && result.EntryStartOption === 3)
                    result.EntryStartOption = 1; // freie Wahl des Zugangsbeginns bei tagesgenauen Verträgen macht kein Sinn -> Zugangsbeginn = Abschlussdatum

                if (vm.selectedMembership.FesterVertragsbeginn.FV_OE === 1) {
                    result.FreeSelectEndDate = moment().startOf("day").add(vm.selectedMembership.FesterVertragsbeginn.FV_OE_Tage, "days").toDate();
                } else if (vm.selectedMembership.FesterVertragsbeginn.FV_OE === 2) {
                    result.FixDate = true;
                    result.FreeSelect = false;
                } else if (vm.selectedMembership.FesterVertragsbeginn.FV_OE === 3) {
                    result.FixDate = true;
                    result.FreeSelect = false;
                    let today = moment();
                    if (today.isoWeekday() <= vm.selectedMembership.FesterVertragsbeginn.FV_NW)
                        result.ContractStart = moment().startOf("day").isoWeekday(vm.selectedMembership.FesterVertragsbeginn.FV_NW).toDate();
                    else
                        result.ContractStart = moment().startOf("day").add(1, "week").isoWeekday(vm.selectedMembership.FesterVertragsbeginn.FV_NW).toDate();
                } else if (vm.selectedMembership.FesterVertragsbeginn.FV_OE === 4) {
                    result.FixDate = true;
                    result.FreeSelect = false;
                    let today = moment().startOf("day");
                    let date1 = (today.date() === 1) ? today : moment().startOf("day").date(1).add(1, "month");
                    let date15 = moment().startOf("day").date(15);
                    if (date15 < today)
                        date15.add(1, "month");

                    if (vm.selectedMembership.FesterVertragsbeginn.FV_NdM_1 && vm.selectedMembership.FesterVertragsbeginn.FV_NdM_15) {
                        result.FixDate = false;
                        result.Select1Or15 = true;
                        if (date1 < date15)
                            result.Select1Or15Dates = [date1.toDate(), date15.toDate()];
                        else
                            result.Select1Or15Dates = [date15.toDate(), date1.toDate()];
                    } else if (vm.selectedMembership.FesterVertragsbeginn.FV_NdM_1)
                        result.ContractStart = date1.toDate();
                    else if (vm.selectedMembership.FesterVertragsbeginn.FV_NdM_15)
                        result.ContractStart = date15.toDate();
                }
                setVertragsoptionenOptions(result)
            }

        }

        vm.pflichtPreise = _.sumBy(vm.pflichtZusatztarife, 'price') + _.sumBy(vm.pflichtGebuehren, 'price');
        vm.pflichtGebuehrenUndPauschalenPreise = _.sumBy(vm.pflichtGebuehren, 'price');
        vm.pflichtZusatztarifePreise = _.sumBy(vm.pflichtZusatztarife, 'price');

        if (vm.selectedAdditionsGesamt || vm.selectedPauschalenWithMembershipZyklusPreisGesamt) {
            vm.summeMitgliedschaft = vm.pflichtPreise ? vm.selectedMembership.Preis + vm.pflichtPreise + vm.selectedAdditionsGesamt + vm.selectedPauschalenWithMembershipZyklusPreisGesamt :
                vm.selectedMembership.Preis + vm.selectedAdditionsGesamt + vm.selectedPauschalenWithMembershipZyklusPreisGesamt;
        } else {
            vm.summeMitgliedschaft = vm.pflichtPreise ? vm.selectedMembership.Preis + vm.pflichtPreise :
                vm.selectedMembership.Preis;
        }
        // if ((vm.selectedAdditionsPauschalen && vm.selectedAdditionsPauschalen.length === 0) && (vm.selectedAdditionsGebuehren && vm.selectedAdditionsGebuehren.length === 0)) {
        //     vm.sizeGebuehrenUndPauschalen = _.size(vm.pflichtGebuehren);
        //     vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehrenOrig, 'zahlzyklus');
        //     _.forEach(vm.pflichtGebuehren, function (g) {
        //         g.gesamt = _.sumBy(g, 'price');
        //         g.zahlzyklusName = g[0].zahlzyklus
        //     });
        //
        //     vm.selectedGebuehrenPauschalenGesamt = _.sumBy(vm.pflichtGebuehren, function (o) {
        //         return o.price;
        //     });
        // } else {
        //     if (vm.pflichtGebuehrenOrig.length > 0) {
        //         vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren, vm.pflichtGebuehrenOrig);
        //         vm.pflichtGebuehren = vm.pflichtGebuehren.filter(element => {
        //             return element !== undefined;
        //         });
        //         vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
        //     } else {
        //         vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren);
        //         vm.pflichtGebuehren = vm.pflichtGebuehren.filter(element => {
        //             return element !== undefined;
        //         });
        //         vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
        //     }
        //
        //     _.forEach(vm.pflichtGebuehren, function (g) {
        //         g.gesamt = _.sumBy(g, 'price');
        //         g.zahlzyklusName = g[0].zahlzyklus
        //     });
        //     if (vm.pflichtGebuehrenOrig.length > 0) {
        //         let selectedGebuehrenPauschalen = _.concat(vm.selectedAdditionsGebuehren, vm.selectedAdditionsPauschalen, vm.pflichtGebuehrenOrig)
        //         selectedGebuehrenPauschalen = selectedGebuehrenPauschalen.filter(element => {
        //             return element !== undefined;
        //         });
        //         vm.selectedGebuehrenPauschalenGesamt = _.sumBy(selectedGebuehrenPauschalen, function (o) {
        //             return o.price;
        //         });
        //     } else {
        //         let selectedGebuehrenPauschalen = _.concat(vm.selectedAdditionsGebuehren, vm.selectedAdditionsPauschalen)
        //         selectedGebuehrenPauschalen = selectedGebuehrenPauschalen.filter(element => {
        //             return element !== undefined;
        //         });
        //         vm.selectedGebuehrenPauschalenGesamt = _.sumBy(selectedGebuehrenPauschalen, function (o) {
        //             return o.price;
        //         });
        //     }
        // }
        vm.sizeGrupedPrices = _.size(vm.groupedPricesWithoutBasistarif);
        vm.sizeGebuehrenUndPauschalen = _.size(vm.pflichtGebuehren);
        vm.locationMembershipBuy = true;
        vm.locationClub = false;
        vm.locationCycles = false;
        vm.locationAdditions = false;
        vm.locationExtraAdditions = false;
        vm.locationSurveys = false;
        vm.concatAdditionsAndExtraWithoutBasistarif = _.concat(vm.selectedAdditions, vm.selectedAdditionsGebuehren, vm.selectedAdditionsPauschalen, vm.pflichtGebuehren);
        vm.concatAdditionsAndExtraAdditions = _.concat(vm.selectedAdditions, vm.selectedAdditionsGebuehren, vm.selectedAdditionsPauschalen, vm.basistarif, vm.pflichtGebuehren);
        vm.concatAdditionsAndExtraWithoutBasistarif = vm.concatAdditionsAndExtraWithoutBasistarif.filter(element => {
            return element !== undefined;
        });
        vm.concatAdditionsAndExtraAdditions = vm.concatAdditionsAndExtraAdditions.filter(element => {
            return element !== undefined;
        });
        vm.groupedPricesSurveys = _.groupBy(vm.concatAdditionsAndExtraAdditions, 'zahlzyklus');
        _.forEach(vm.groupedPricesSurveys, function (g) {
            g.gesamt = _.sumBy(g, 'price');
            g.zahlzyklusName = g[0].zahlzyklus
        })
        vm.groupedPricesWithoutBasistarif = _.groupBy(vm.concatAdditionsAndExtraWithoutBasistarif, 'zahlzyklus');
        _.forEach(vm.groupedPricesWithoutBasistarif, function (g) {
            g.gesamt = _.sumBy(g, 'price');
            g.zahlzyklusName = g[0].zahlzyklus
        })

        function recalculatePartialSum() {
            let calculationStartDate = moment(vm.selectedMembership.Zugangsbeginn).startOf("day");
            let calculationEndDate = moment(vm.selectedMembership.Vertragsbeginn).startOf("day");
            let duration = calculationEndDate.diff(calculationStartDate, "days");

            if (!vm.selectedMembership.BerechneTeilbetrag || duration <= 0 || vm.selectedMembership.Zahlzyklus === 0) {
                vm.Teilbetrag = {Summe: 0, Betraege: []};
                if(vm.selectedMembership.Vertragsbeginn) {
                    gesamtpreis()
                }
                return;
            }

            let cycle = "d";
            if (vm.selectedMembership.ZahlzyklusEinheit === 1)
                cycle = "w";
            else if (vm.selectedMembership.ZahlzyklusEinheit === 2)
                cycle = "M";
            else if (vm.selectedMembership.ZahlzyklusEinheit === 3)
                cycle = "y";

            let cycleEndDate = moment(vm.selectedMembership.Zugangsbeginn).startOf("day").add(vm.selectedMembership.Zahlzyklus, cycle);
            let cycleDays = cycleEndDate.diff(calculationStartDate, "days");

            let result = {Summe: _.round(vm.selectedMembership.Preis / cycleDays * duration, 2)};
            if (!_.isEmpty(vm.selectedAdditions)) {
                result.Betraege = [{Cost: result.Summe, Name: vm.selectedMembership.MitgliedschaftsName}];
                _.forEach(vm.selectedAdditions, function (add) {
                    if (!add.istPauschale) {
                        let cost = {Cost: _.round(add.price / cycleDays * duration, 2), Name: add.Bezeichnung};
                        result.Betraege.push(cost);
                        result.Summe += cost.Cost;
                    }
                });
                if (result.Betraege.length === 1) // nur Pauschalen drin, keine Zusatztarife
                    result.Betraege = null;
            }

            vm.Teilbetrag = result;
            if(vm.selectedMembership.Vertragsbeginn) {
                gesamtpreis()
            }
        }

       // recalculatePartialSum();


        vm.recalcPartialCost = function () {
            vm.dateErrorZB = false;
            vm.dateErrorVB = false;
            if (vm.contractOptions.EntryStartOption === 1)
                vm.selectedMembership.Zugangsbeginn = moment().startOf("day").toDate();
            else if (vm.contractOptions.EntryStartOption === 2)
                vm.selectedMembership.Zugangsbeginn = vm.selectedMembership.Vertragsbeginn;

            if (vm.contractOptions.FreeSelect || vm.contractOptions.EntryStartOption === 3) {
                let testZB = moment(vm.selectedMembership.Zugangsbeginn).startOf("day").toDate();
                let testVB = moment(vm.selectedMembership.Vertragsbeginn).startOf("day").toDate();
                if (testZB < vm.today || testZB > testVB) {
                    vm.dateErrorZB = (vm.contractOptions.EntryStartOption === 3);
                    vm.dateErrorVB = (vm.contractOptions.FreeSelect);
                    vm.Teilbetrag = {Summe: 0, Betraege: []};
                    return;
                }
            }

            recalculatePartialSum();
            if(vm.selectedMembership.Vertragsbeginn) {
                gesamtpreis()
            }
        };

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/agbOnlineSales.html",
                controller: "OnlineSalesPrivacyTermsDialogController",
                controllerAs: "vm"
            });
        };

        vm.openWDR = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/wdrOnlineSales.html",
                controller: "OnlineSalesWDRDialogController",
                controllerAs: "vm"
            });
        };

        vm.checkCoupon = function () {
            if (vm.couponNr === '') {
                vm.coupon = null;
                vm.couponNr = null;
                vm.couponChecked = false;
                vm.selectedMembership.CouponCode = null;
                vm.couponError = false;
            } else {
                vm.spinnerCoupon = true;
                vm.selectedMembership.CouponCode = vm.couponNr;
                BookingService.checkCoupon(vm.couponNr, vm.selectedMembership.MitgliedschaftsNr).then(function (data) {
                    vm.coupon = data;
                    // vm.isValidCoupon = data.IsValid;
                    // vm.couponKampagneName = data.Werbekampagne;
                    vm.couponNr = data.CouponCode ? data.CouponCode : vm.selectedMembership.CouponCode;
                    vm.couponChecked = true;
                    vm.spinnerCoupon = false;
                    if(vm.selectedMembership.Vertragsbeginn) {
                        gesamtpreis()
                    }
                }).catch(function () {
                    vm.couponError = true;
                    vm.selectedMembership.Coupon = null;
                    vm.spinnerCoupon = false
                })
            }
        }

        //Signature canvas

        vm.drawInit = function () {

            var canvasWidth = 400;                           //canvas width
            var canvasHeight = 60;
            if (document.getElementById("canvas") != null) {//canvas height
                var canvas = document.getElementById('canvas');  //canvas element
                var context = canvas.getContext("2d");           //context element
                var clickX = [];
                var clickY = [];
                vm.clickDrag = [];
                var paint;

                canvas.addEventListener("mousedown", mouseDown, false);
                canvas.addEventListener("mousemove", mouseXY, false);
                document.body.addEventListener("mouseup", mouseUp, false);

                //For mobile

                canvas.addEventListener("touchstart", mouseDown, false);
                canvas.addEventListener("touchmove", mouseXYTouch, false);
                canvas.addEventListener("touchend", mouseUp, false);

                //  document.body.addEventListener("touchcancel", mouseUp, false);

                function draw() {
                    vm.isSignature = true;

                    context.clearRect(0, 0, canvas.width, canvas.height); // Clears the canvas

                    context.strokeStyle = "#000000";  //set the "ink" color
                    context.lineJoin = "miter";       //line join
                    context.lineWidth = 2;            //"ink" width

                    for (var i = 0; i < clickX.length; i++) {
                        context.beginPath();                               //create a path
                        if (vm.clickDrag[i] && i) {
                            context.moveTo(clickX[i - 1], clickY[i - 1]);  //move to
                        } else {
                            context.moveTo(clickX[i] - 1, clickY[i]);      //move to
                        }
                        context.lineTo(clickX[i], clickY[i]);              //draw a line
                        context.stroke();                                  //filled with "ink"
                        context.closePath();                               //close path
                    }

                }

                //Save the Sig
                $("#saveSig").click(function saveSig() {
                    var sigData = canvas.toDataURL("image/png");
                    $("#imgData").text(sigData);
                });

                function addClick(x, y, dragging) {
                    clickX.push(x);
                    clickY.push(y);
                    vm.clickDrag.push(dragging);
                }

                function mouseXY(e) {
                    if (paint) {
                        addClick(e.pageX - this.offsetLeft, e.pageY - this.offsetTop, true);
                        draw();
                    }
                }

                function mouseXYTouch(e) {
                    e.preventDefault();
                    if (paint) {
                        addClick(e.touches[0].pageX - this.offsetLeft, e.touches[0].pageY - this.offsetTop, true);
                        draw();
                    }
                }

                function mouseUp() {
                    paint = false;
                }

                function mouseDown(e) {
                    var mouseX = e.pageX - this.offsetLeft;
                    var mouseY = e.pageY - this.offsetTop;

                    paint = true;
                    addClick(e.pageX - this.offsetLeft, e.pageY - this.offsetTop);
                    draw();
                }

            }
            //Clear the Sig
            vm.clearSignatur = function () {
                clickX = [];
                clickY = [];
                vm.clickDrag = [];
                context.clearRect(0, 0, canvas.width, canvas.height);
                $("#imgData").html('');
                vm.isSignature = false;
            };
        }

        vm.checkIban = function () {
            if (!_.isUndefined(vm.member.iban))
                return BookingService.isIbanValid(vm.member.iban).then(
                    function (valid) {
                        if (_.isUndefined(valid.isValid)) {
                            if (!valid) {
                                vm.memberIban = false
                                vm.isDEIban = false;
                            } else {
                                vm.memberIban = true
                                vm.isDEIban = true;
                            }

                        } else {
                            if (valid.isValid && valid.isDE) {
                                vm.memberIban = true
                                vm.isDEIban = true;

                            }

                            if (valid.isValid && !valid.isDE) {
                                vm.memberIban = true
                                vm.isDEIban = false;
                            }
                            if (!valid.isValid) {
                                vm.memberIban = false
                                vm.isDEIban = false;
                            }
                        }

                    }
                )

        }

        vm.errorRequiredSignature = false;
        vm.privacyterms = false;
        vm.wdr = false;
        vm.einwilligung1Checked = false;
        vm.einwilligung2Checked = false;
        let abschliessen = false;
        vm.spinner = false;


        vm.showChangedMemberData = function () {
            vm.memberValuesHasChangedChecked = true;
        };

        vm.checkChangedMemberData = function (memberFormValid) {
            vm.memberFormValid = memberFormValid;
            if (vm.selectedMembership.AngebotId || vm.member.Id) {
                vm.changedMemberValues = [];
                if (vm.member.Vorname !== vm.member.firstname) {
                    vm.changedMemberValues.push("Vorname")
                }
                if (vm.member.Nachname !== vm.member.lastname) {
                    vm.changedMemberValues.push("Nachname")
                }
                if (vm.member.Email !== vm.member.email) {
                    vm.changedMemberValues.push("Email")
                }
                if (!(_.isUndefined(vm.member.Geburtsdatum) && vm.member.birthday === null)) {
                    if (!_.isEqual(new Date(vm.member.Geburtsdatum), new Date(vm.member.birthday))) {
                        vm.changedMemberValues.push("Geburtsdatum")
                    }
                }
                if (vm.member.Mobil !== vm.member.mobile && !(_.isUndefined(vm.member.Mobil) && vm.member.mobile === '')) {
                    vm.changedMemberValues.push("Mobil")
                }
                if (vm.member.StrasseNr !== vm.member.street && !(_.isUndefined(vm.member.StrasseNr) && (vm.member.street === ''))) {
                    vm.changedMemberValues.push("StrasseHNr")
                }
                if (vm.member.Plz !== vm.member.zipcode && !(vm.member.Plz !== '' && !_.isUndefined(vm.member.Plz) && (vm.member.zipcode !== ''))) {
                    vm.changedMemberValues.push("PLZ")
                }
                if (vm.member.Stadt !== vm.member.city) {
                    vm.changedMemberValues.push("Ort")
                }
                if (vm.member.Iban !== vm.member.iban) {
                    vm.changedMemberValues.push("Iban")
                }
                if (vm.member.Bic !== vm.member.bic && !_.isUndefined(vm.member.bic)) {
                    vm.changedMemberValues.push("Bic")
                }
                if (vm.member.Kontoinhaber !== vm.member.accountOwnerfirstname + ' ' + vm.member.accountOwnerlastname) {
                    vm.changedMemberValues.push("Kontoinhaber")
                }
            }
        };

        vm.abschliessen = async function (valid, status, email, print) {
            vm.hasBuyError = false;
            vm.hasGeneralError = false;
            vm.errorAge = false;

            vm.dateErrorZB = false;
            vm.dateErrorVB = false;
            //ToDo muss hier beim Angebot validiert werden?
            if (vm.contractOptions.FreeSelect || vm.contractOptions.EntryStartOption === 3) {
                let testZB = moment(vm.selectedMembership.Zugangsbeginn).startOf("day").toDate();
                let testVB = moment(vm.selectedMembership.Vertragsbeginn).startOf("day").toDate();
                if (testZB < vm.today || testZB > testVB) {
                    vm.dateErrorZB = (vm.contractOptions.EntryStartOption === 3);
                    vm.dateErrorVB = (vm.contractOptions.FreeSelect);
                    return;
                }
            }
            if (status === true) {
                try {
                    vm.member.mandantId = vm.selectedMandantNr.toString();
                } catch (err) {
                    console.error(err.message)
                }
                abschliessen = true;
                vm.spinner = true;
                vm.member.source = 4;
                //  vm.selectedMembership = vm.member;
                vm.selectedMembership.Gebuehren = vm.selectedAdditionsGebuehren ? Object.values(vm.selectedAdditionsGebuehren) : [];
                vm.selectedMembership.Pauschalen = vm.selectedAdditionsPauschalen ? Object.values(vm.selectedAdditionsPauschalen) : [];
                vm.selectedMembership.ZusatztarifeOrig = vm.parent.selectedMembershipZTToSelect;
                vm.selectedMembership.GebuehrenOrig = vm.parent.selectedMembershipGebuehrenToSelect;
                vm.selectedMembership.PauschalenOrig = vm.parent.selectedMembershipPauschalenToSelect;
                vm.selectedMembership.VertragsbeginnOrig = vm.selectedMembership.Vertragsbeginn;
                vm.selectedMembership.ZugangsbeginnOrig = vm.selectedMembership.Zugangsbeginn;
                vm.selectedMembership.Zusatztarife = [];
                _.forEach(vm.selectedAdditions, function (add) {
                    if (add.istPauschale)
                        vm.selectedMembership.Pauschalen.push(add);
                    else
                        vm.selectedMembership.Zusatztarife.push(add);
                });

                vm.selectedMembership.Basistarif = [{
                    Bezeichnung: "Basistarif",
                    price: vm.selectedMembership.Preis,
                    zahlzyklus: vm.selectedMembership.ZahlzyklusName
                }];
                vm.selectedMembership.Pflichtgebuehren = vm.pflichtGebuehren;
                vm.selectedMembership.SelectedAdditions = vm.selectedAdditions;
                vm.selectedMembership.SelectedAdditionsPauschalen = vm.parent.selectedPauschalen;
                vm.selectedMembership.SelectedAdditionsGebuehren = vm.parent.selectedGebuehren;
                vm.selectedMembership.SelectedAdditionsGesamt = vm.parent.selectedAdditionsGesamt;
                vm.selectedMembership.PflichtgebuehrenOrig = vm.pflichtGebuehrenOrig;
                vm.selectedMembership.HasZusatztarifeWithPrice = vm.parent.hasZusatztarifeWithPrice;
                vm.selectedMembership.HasPauschalenwithPrice = vm.parent.hasPauschalenWithPrice;
                vm.selectedMembership.HasGebuehrenWithPrice = vm.parent.hasGebuehrenWithPrice;

                // if(vm.pflichtGebuehren) {
                //     vm.selectedMembership.AngebotPflichtgebuehren = Object.keys(vm.pflichtGebuehren).map(key => {
                //         let ar = vm.pflichtGebuehren[key]
                //         ar.key = key
                //         return ar
                //     });
                //     vm.selectedMembership.AngebotPflichtgebuehren = _.flattenDeep(vm.selectedMembership.AngebotPflichtgebuehren);
                // } else {
                //     vm.selectedMembership.AngebotPflichtgebuehre = [];
                // }

                if (vm.selectedAdditions) {
                    vm.selectedMembership.AngebotSelectedAdditions = Object.keys(vm.selectedAdditions).map(key => {
                        let ar = vm.selectedAdditions[key]
                        ar.key = key
                        return ar
                    });
                    vm.selectedMembership.AngebotSelectedAdditionsIds = vm.selectedAdditionsIds;
                } else {
                    vm.selectedMembership.AngebotSelectedAdditions = [];
                }

                if (vm.parent.selectedAdditionsPauschalen || vm.selectedPauschalenWithMembershipZyklus) {

                    let angebotSelectedAdditionsPauschalen = Object.keys(vm.parent.selectedAdditionsPauschalen).map(key => {
                        let ar = vm.parent.selectedAdditionsPauschalen[key]
                        ar.key = key
                        return ar
                    });

                    let selectedPauschalenWithMembershipZyklus = Object.keys(vm.selectedPauschalenWithMembershipZyklus).map(key => {
                        let ar = vm.selectedPauschalenWithMembershipZyklus[key]
                        ar.key = key
                        return ar
                    });

                    vm.selectedMembership.AngebotSelectedAdditionsPauschalen = _.concat(angebotSelectedAdditionsPauschalen, selectedPauschalenWithMembershipZyklus)
                    vm.selectedMembership.AngebotSelectedAdditionsPauschalenIds = _.concat(vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklusIds);
                } else {
                    vm.selectedMembership.AngebotSelectedAdditionsPauschalen = [];
                }
                if (vm.selectedPauschalenWithMembershipZyklus) {
                    vm.selectedMembership.AngebotSelectedPauschalenWithMembershipZyklus = Object.keys(vm.selectedPauschalenWithMembershipZyklus).map(key => {
                        let ar = vm.selectedPauschalenWithMembershipZyklus[key]
                        ar.key = key
                        return ar
                    });
                    vm.selectedMembership.AngebotSelectedPauschalenWithMembershipZyklusIds = vm.selectedPauschalenWithMembershipZyklusIds;
                } else {
                    vm.selectedMembership.AngebotSelectedPauschalenWithMembershipZyklus = [];
                }

                if (vm.parent.selectedAdditionsGebuehren) {
                    vm.selectedMembership.AngebotSelectedAdditionsGebuehren = Object.keys(vm.parent.selectedAdditionsGebuehren).map(key => {
                        let ar = vm.parent.selectedAdditionsGebuehren[key]
                        ar.key = key
                        return ar
                    });
                    vm.selectedMembership.AngebotSelectedAdditionsGebuehrenIds = vm.selectedAdditionsGebuehrenIds;
                } else {
                    vm.selectedMembership.AngebotSelectedAdditionsGebuehren = [];
                }


                if (vm.contractOptions.EntryStartOption === 1)
                    vm.selectedMembership.Zugangsbeginn = moment().startOf("day").toDate();
                else if (vm.contractOptions.EntryStartOption === 2)
                    vm.selectedMembership.Zugangsbeginn = vm.selectedMembership.Vertragsbeginn;

                vm.member.Kontoinhaber = !_.isUndefined(vm.member.accountOwnerfirstname) && !_.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerfirstname + ' ' + vm.member.accountOwnerlastname :
                    !_.isUndefined(vm.member.accountOwnerfirstname) && _.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerfirstname :
                        _.isUndefined(vm.member.accountOwnerfirstname) && !_.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerlastname : '';


                vm.memberAngebot = {};
                vm.memberAngebot.source = vm.member.source;
                vm.memberAngebot.mandantId = vm.member.mandantId;
                vm.memberAngebot.Id = vm.member.Id;
                vm.memberAngebot.title = vm.member.title;
                vm.memberAngebot.firstname = vm.member.firstname;
                vm.memberAngebot.lastname = vm.member.lastname;
                vm.memberAngebot.birthday = vm.member.birthday;
                vm.memberAngebot.email = vm.member.email;
                vm.memberAngebot.mobile = vm.member.mobile;
                vm.memberAngebot.street = vm.member.street;
                vm.memberAngebot.zipcode = vm.member.zipcode;
                vm.memberAngebot.city = vm.member.city;
                vm.memberAngebot.iban = vm.member.iban;
                vm.memberAngebot.bic = vm.member.bic;
                vm.memberAngebot.accountOwnerfirstname = vm.member.accountOwnerfirstname;
                vm.memberAngebot.accountOwnerlastname = vm.member.accountOwnerlastname;
                vm.saveAngebot = {Member: vm.memberAngebot, Angebot: vm.selectedMembership};
                BookingService.saveOnlineSalesAngebot(vm.saveAngebot, email, $stateParams.abt).then(function (result) {
                    vm.showFormular = false;
                    abschliessen = false;
                    vm.spinner = false;
                    vm.istAngebot = true;
                    vm.savedAngebotId = result.AngebotId;
                    if (print) {
                        vm.pdfAngebot = result.AngebotPdf;
                        vm.parent.goToAbgeschlossen(true, vm.savedAngebotId, email);
                        printAngebotPdf();
                    } else {
                        vm.parent.goToAbgeschlossen(true, vm.savedAngebotId, email)
                    }


                    // if (vm.onlineSalesConfig.LandingPage === false) {
                    //     $('html, body').animate({
                    //         scrollTop: 0
                    //     }, 'fast');
                    // } else {
                    //     if (window.location !== window.parent.location) {
                    //         if (_.startsWith(vm.onlineSalesConfig.LandingPageUrl, "http") || _.startsWith(vm.onlineSalesConfig.LandingPageUrl, "https")) {
                    //             document.getElementById("landingPageWithout").click();
                    //         } else {
                    //             document.getElementById("landingPageWith").click();
                    //         }
                    //
                    //         // The page is in an iframe
                    //     } else {
                    //         if (_.startsWith(vm.onlineSalesConfig.LandingPageUrl, "http") || _.startsWith("https", vm.onlineSalesConfig.LandingPageUrl, "https")) {
                    //             document.getElementById("landingPageNewTabWithout").click();
                    //         } else {
                    //             document.getElementById("landingPageNewTabWith").click();
                    //         }
                    //         // The page is not in an iframe
                    //     }
                    //     //window.location.href = vm.onlineSalesConfig.LandingPageUrl;
                    // }
                }).catch(err => {
                    vm.savedContract = false;
                    if (err.status === 400) {
                        vm.hasBuyError = true;
                        abschliessen = false;
                        vm.spinner = false;
                    } else {
                        vm.hasGeneralError = true;
                        abschliessen = false;
                        vm.spinner = false;
                    }
                })


            } else {

                if (vm.couponNr && vm.coupon.IsValid === true) {
                    vm.selectedMembership.CouponCode = vm.couponNr;
                }

                if (vm.couponNr && vm.coupon.IsValid === false) {
                    return
                }

                if (vm.onlineSalesConfig.GesamtpreisAngabe === 1) {
                    vm.selectedMembership.GesamtpreisAngabe = true;
                } else {
                    vm.selectedMembership.GesamtpreisAngabe = false;
                }

                if (vm.onlineSalesConfig.Signatur === 1) {
                    if (vm.isSignature === true) {
                        var canvas = document.getElementById('canvas');
                        vm.imgCanvas = canvas.toDataURL("image/png");
                        vm.selectedMembership.Signatur = vm.imgCanvas;
                        vm.errorRequiredSignature = false;
                    } else {
                        vm.errorRequiredSignature = true;
                    }
                    // var canvas = document.getElementById('canvas');
                    // let docBlankCanvas = document.getElementById('canvas_blank').toDataURL();
                    // let canvasImg = canvas.toDataURL("image/png");
                    // if (canvasImg === docBlankCanvas) {
                    //     vm.signaturValidation = false;
                    // } else {
                    //     vm.imgCanvas = canvas.toDataURL("image/png");
                    //     vm.selectedMembership.Signatur = vm.imgCanvas;
                    // }
                }

                if (valid && vm.memberZip && (!vm.selectedMembership.IstLastschrift || (vm.selectedMembership.IstLastschrift && (vm.memberIban === true || (valid && vm.angebot)))) && !abschliessen &&
                    ((vm.onlineSalesConfig.Signatur === 1 && vm.isSignature === true) ||
                        ((vm.onlineSalesConfig.Signatur === null || vm.onlineSalesConfig.Signatur === 0)))) {
                    let alter = moment().diff(vm.member.birthday, "years");
                    if ((vm.selectedMembership.Mindestalter && vm.selectedMembership.Mindestalter > alter) ||
                        (vm.selectedMembership.Maximalalter && alter > vm.selectedMembership.Maximalalter)) {
                        vm.errorAge = true;
                        return;
                    }

                    try {
                        vm.member.mandantId = vm.selectedMandantNr.toString();
                    } catch (err) {
                        console.error(err.message)
                    }
                    abschliessen = true;
                    vm.spinner = true;
                    vm.member.source = 4;
                    vm.selectedMembership.Member = vm.member;
                    vm.selectedMembership.Gebuehren = vm.selectedAdditionsGebuehren ? Object.values(vm.selectedAdditionsGebuehren) : [];
                    vm.selectedMembership.Pauschalen = vm.selectedAdditionsPauschalen || vm.selectedPauschalenWithMembershipZyklus ? _.concat(Object.values(vm.selectedAdditionsPauschalen), vm.selectedPauschalenWithMembershipZyklus) : [];
                    vm.selectedMembership.Zusatztarife = [];
                    vm.selectedMembership.PflichtgebuehrenOrig = vm.pflichtGebuehrenOrig;
                    _.forEach(vm.selectedAdditions, function (add) {
                        if (add.istPauschale)
                            vm.selectedMembership.Pauschalen.push(add);
                        else
                            vm.selectedMembership.Zusatztarife.push(add);
                    });
                    vm.selectedMembership.Member.iban = _.upperCase(vm.selectedMembership.Member.iban);

                    if (vm.contractOptions.EntryStartOption === 1)
                        vm.selectedMembership.Zugangsbeginn = moment().startOf("day").toDate();
                    else if (vm.contractOptions.EntryStartOption === 2)
                        vm.selectedMembership.Zugangsbeginn = vm.selectedMembership.Vertragsbeginn;

                    BookingService.saveOnlineSalesContract(vm.selectedMembership).then(function (resultPdf) {
                        vm.pdfContract = resultPdf;
                        vm.showFormular = false;
                        abschliessen = false;
                        vm.spinner = false;
                        if (vm.angebot) {
                            vm.parent.goToAbgeschlossen(false, null, false, vm.pdfContract)
                            vm.isVertrag = true;
                            vm.istVertrag = true;
                            vm.vertragSaved = true;

                        } else {
                            if (vm.onlineSalesConfig.LandingPage === false) {
                                $('html, body').animate({
                                    scrollTop: 0
                                }, 'fast');
                            } else {

                                if (window.location !== window.parent.location) {
                                    if (_.startsWith(vm.onlineSalesConfig.LandingPageUrl, "http") || _.startsWith(vm.onlineSalesConfig.LandingPageUrl, "https")) {
                                        vm.landingPageWithoutNoIframe = true;
                                        vm.landingPageId = "landingPageWithoutNoIframe";
                                    } else {
                                        vm.landingPageWithNoIframe = true;
                                        vm.landingPageId = "landingPageWithNoIframe";

                                    }
                                } else {
                                    if (_.startsWith(vm.onlineSalesConfig.LandingPageUrl, "http") || _.startsWith(vm.onlineSalesConfig.LandingPageUrl, "https")) {
                                        vm.landingPageWithoutNoIframe = true;
                                        vm.landingPageId = "landingPageWithoutNoIframe";
                                    } else {
                                        vm.landingPageWithNoIframe = true;
                                        vm.landingPageId = "landingPageWithNoIframe";
                                    }

                                }
                                document.getElementById(vm.landingPageId).click();
                            }
                        }
                    }).catch(err => {
                        vm.savedContract = false;
                        if (err.status === 400) {
                            vm.hasBuyError = true;
                            abschliessen = false;
                            vm.spinner = false;
                        } else {
                            vm.hasGeneralError = true;
                            abschliessen = false;
                            vm.spinner = false;
                        }
                    })
                }
            }

        };

        vm.kostenpflichtigBestellen = function (valid) {
            vm.isVertrag = true;
            vm.isAngebot = false;

            if (valid) {
                vm.member.Vorname = vm.member.firstname;
                vm.member.Nachname = vm.member.lastname;
                vm.member.Geschlecht = vm.member.title;
                vm.member.Geburtsdatum = vm.member.birthday;
                vm.member.Email = vm.member.email;
                vm.member.StrasseNr = vm.member.street;
                vm.member.Plz = vm.member.zipcode;
                vm.member.Stadt = vm.member.city;
                vm.member.Mobil = vm.member.mobile;
                vm.member.Iban = vm.member.iban;
                vm.member.Bic = vm.member.bic;
                vm.member.Kontoinhaber = !_.isUndefined(vm.member.accountOwnerfirstname) && !_.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerfirstname + ' ' + vm.member.accountOwnerlastname :
                    !_.isUndefined(vm.member.accountOwnerfirstname) && _.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerfirstname :
                        _.isUndefined(vm.member.accountOwnerfirstname) && !_.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerlastname : '';
                vm.parent.goToAbschluss(vm.isVertrag, vm.isAngebot, vm.member)
            }

        };

        vm.angebotErstellen = function (valid) {
            vm.isAngebot = true;
            vm.isVertrag = false;
            if (valid) {
                vm.member.Vorname = vm.member.firstname;
                vm.member.Nachname = vm.member.lastname;
                vm.member.Geschlecht = vm.member.title;
                vm.member.Geburtsdatum = vm.member.birthday;
                vm.member.Email = vm.member.email;
                vm.member.StrasseNr = vm.member.street;
                vm.member.Plz = vm.member.zipcode;
                vm.member.Stadt = vm.member.city;
                vm.member.Mobil = vm.member.mobile;
                vm.member.Iban = vm.member.iban;
                vm.member.Bic = vm.member.bic;
                vm.member.Kontoinhaber = !_.isUndefined(vm.member.accountOwnerfirstname) && !_.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerfirstname + ' ' + vm.member.accountOwnerlastname :
                    !_.isUndefined(vm.member.accountOwnerfirstname) && _.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerfirstname :
                        _.isUndefined(vm.member.accountOwnerfirstname) && !_.isUndefined(vm.member.accountOwnerlastname) ? vm.member.accountOwnerlastname : '';
                vm.parent.goToAbschluss(vm.isVertrag, vm.isAngebot, vm.member)
            }
        };

        vm.refreshAngebotDatum = function () {
            vm.selectedFoundAngebotDatum = false;
            vm.choosenMemberAngebotDatum = false;
            vm.refreshDatums = true;
        };

        vm.kostenpflichtigBestellenChoosen = function (memberFormValid) {
            vm.memberValuesHasChangedChecked = true;
            vm.chooseAngebot = false;
            vm.isAngebot = false;
            vm.isVertrag = true;

            const vertragsbeginnDateOnly = vm.selectedMembership.Vertragsbeginn instanceof Date
                ? new Date(vm.selectedMembership.Vertragsbeginn.getFullYear(), vm.selectedMembership.Vertragsbeginn.getMonth(), vm.selectedMembership.Vertragsbeginn.getDate())
                : new Date(vm.selectedMembership.Vertragsbeginn.split('T')[0]);

            const zugangsbeginnDateOnly = vm.selectedMembership.Zugangsbeginn instanceof Date
                ? new Date(vm.selectedMembership.Zugangsbeginn.getFullYear(), vm.selectedMembership.Zugangsbeginn.getMonth(), vm.selectedMembership.Zugangsbeginn.getDate())
                : new Date(vm.selectedMembership.Zugangsbeginn.split('T')[0]);

            const heute = new Date();
            heute.setHours(0, 0, 0, 0);

            if (zugangsbeginnDateOnly < heute || zugangsbeginnDateOnly > vertragsbeginnDateOnly) {
                vm.dateErrorZB = (vm.contractOptions.EntryStartOption === 3);
                vm.dateErrorVB = (vm.contractOptions.FreeSelect);
                memberFormValid = false;
            }

            vm.memberFormValid = memberFormValid;
            if (vm.chooseKostenpflichtig) {
                vm.chooseKostenpflichtig = false;
            } else {
                vm.chooseKostenpflichtig = true;
            }
        }

        vm.angebotErstellenChoosen = function (memberFormTitleValid) {
            vm.memberFormValid = memberFormTitleValid;
            vm.isAngebot = true;
            vm.isVertrag = false;
            vm.chooseKostenpflichtig = false;
            if (vm.chooseAngebot) {
                vm.chooseAngebot = false;
            } else {
                vm.chooseAngebot = true;
            }
        }

        vm.goBackOptions = function () {
            if (vm.parent.hasZusatzleistungen === true && (vm.parent.hasPauschalenWithPrice === true || vm.parent.hasGebuehrenWithPrice === true)) {
                vm.parent.goToExtraAdditionsAngebot('extraAdditions', vm.parent.memberSelected, vm.parent.selectedMember, vm.parent.hasZusatzleistungen,
                    vm.parent.hasPauschalenWithPrice, vm.parent.hasGebuehrenWithPrice, vm.member, vm.selectedMembership, vm.choosenMemberAngebot,
                    vm.selectedFoundAngebot, vm.parent.choosenNewangebotForMember, vm.pflichtZusatztarife, vm.selectedAdditions,
                    vm.selectedAdditionsGesamt, vm.pflichtZusatztarifePreis, vm.selectedMembershipAdds, vm.selectedAdditionsIds, vm.selectedAdditionsGebuehrenIds,
                    vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
            } else if ((vm.parent.hasPauschalenWithPrice === null || vm.parent.hasPauschalenWithPrice === false) && (vm.parent.hasGebuehrenWithPrice === false || vm.parent.hasGebuehrenWithPrice === null) && vm.parent.hasZusatztarife === true && vm.parent.zusatztarifenWithPrice['true']) {
                vm.parent.goToAdditionsAngebot('additions', vm.parent.memberSelected, vm.parent.selectedMember, vm.parent.hasZusatztarife, vm.parent.zusatztarifenWithPrice['true'],
                    vm.choosenMemberAngebot, vm.selectedFoundAngebot, vm.selectedAdditions, vm.selectedAdditionsGesamt, vm.selectedMembership,
                    vm.selectedAdditionsGesamt, vm.pflichtZusatztarifePreis, vm.selectedAdditionsIds, vm.selectedAdditionsGebuehrenIds,
                    vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
            } else {
                vm.parent.goToSurveysAngebot('surveys', vm.parent.memberSelected, vm.parent.selectedMember, vm.choosenNewangebotForMember, vm.selectedMembership,
                    vm.selectedMembershipAdds, vm.parent.choosenMembershipIndex, vm.selectedAdditions, vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren,
                    vm.selectedAdditionsGesamt, vm.pflichtZusatztarifePreis, vm.selectedAdditionsIds, vm.selectedAdditionsGebuehrenIds,
                    vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
            }
        }


        vm.printVertragPdf = function () {
            vm.vertragSaved = true;
            var objbuilder = '';
            objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
            objbuilder += (vm.parent.pdfContract);
            objbuilder += ('" type="application/pdf" class="internal">');
            objbuilder += ('</object>');
            var win = window.open("", "_blank");
            win.document.title = "Mitgliedschaft";
            win.document.write('<html><body>');
            win.document.write(objbuilder);
            win.document.write('</body></html>');
//            win.print()


        }

        vm.saveAndPrintVertragPdf = function () {
            vm.abschliessen(true, false, false, true)

        }

        function printAngebotPdf() {
            var objbuilder = '';
            objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
            objbuilder += (vm.pdfAngebot);
            objbuilder += ('" type="application/pdf" class="internal">');
            objbuilder += ('</object>');
            var win = window.open("", "_blank", "titlebar=yes");
            win.document.title = "Angebot";
            win.document.write('<html><body>');
            win.document.write(objbuilder);
            win.document.write('</body></html>');
            //win.print()


            var getMyFrame = document.getElementById('iframe1');
            getMyFrame.focus();
            getMyFrame.contentWindow.print();
        }

        vm.goToAngebot = function () {
            vm.parent.goToAngebot();
        }

        vm.vertragGoToAbgeschlossen = function (valid) {
            if (valid) {
                vm.istVertrag = true;
                vm.parent.goToAbgeschlossen(false);
            }
        }

        vm.checkZip = function (zip) {
            vm.memberZip = true;
            if (zip.length > 5) {
                vm.memberZip = false;
            }
        }

        function gesamtpreis() {
            if (vm.onlineSalesConfig.GesamtpreisAngabe === 1) {
            vm.dateErrorZB = false;
            vm.dateErrorVB = false;
            vm.hasGesamtpreisGeneralError = false;
            vm.hasGesamtpreisError = false;

            if (vm.couponNr && vm.coupon.IsValid === true) {
                vm.selectedMembership.CouponCode = vm.couponNr;
            }

            //ToDo Gesamtpreis kann nicht ermittelt werden?
            if (vm.contractOptions.FreeSelect || vm.contractOptions.EntryStartOption === 3) {
                let testZB = moment(vm.selectedMembership.Zugangsbeginn).startOf("day").toDate();
                let testVB = moment(vm.selectedMembership.Vertragsbeginn).startOf("day").toDate();
                if (testZB < vm.today || testZB > testVB) {
                    vm.dateErrorZB = (vm.contractOptions.EntryStartOption === 3);
                    vm.dateErrorVB = (vm.contractOptions.FreeSelect);
                    return;
                }
            }


            vm.selectedMembership.MandantId = vm.selectedMandantNr.toString();
            vm.selectedMembership.Gebuehren = vm.selectedAdditionsGebuehren ? Object.values(vm.selectedAdditionsGebuehren) : [];
            vm.selectedMembership.Pauschalen = vm.selectedAdditionsPauschalen || vm.selectedPauschalenWithMembershipZyklus ? _.concat(Object.values(vm.selectedAdditionsPauschalen), vm.selectedPauschalenWithMembershipZyklus) : [];
            vm.selectedMembership.Zusatztarife = [];
            vm.selectedMembership.PflichtgebuehrenOrig = vm.pflichtGebuehrenOrig;
            _.forEach(vm.selectedAdditions, function (add) {
                if (add.istPauschale)
                    vm.selectedMembership.Pauschalen.push(add);
                else
                    vm.selectedMembership.Zusatztarife.push(add);
            });

            if (vm.contractOptions.EntryStartOption === 1)
                vm.selectedMembership.Zugangsbeginn = moment().startOf("day").toDate();
            else if (vm.contractOptions.EntryStartOption === 2)
                vm.selectedMembership.Zugangsbeginn = vm.selectedMembership.Vertragsbeginn;

            BookingService.checkGesamtpreis(vm.selectedMembership).then(function (data) {
                let data2 = data.replace(',', '.');
                let parts = data2.split('.');
                let bereinigterString;

                if (parts.length > 1) {
                    bereinigterString = parts[0] + '.' + parts[1].substring(0, 2);
                } else {
                    bereinigterString = parts[0];
                }
                vm.gesamtpreis = parseFloat(bereinigterString);
                vm.checkedGesamtpreis = true;
            }).catch(err => {
                vm.checkedGesamtpreis = false;
                if (err.status === 400) {
                    vm.hasGesamtpreisError = true;
                } else {
                    vm.hasGesamtpreisGeneralError = true;

                }
            })
        }
        }

    }]);